<template>
	<section>
		<!--编辑界面-->
		<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">

		        <el-form-item label="信息类型" prop="info_type">
					 <el-select v-model="editForm.info_type"  placeholder="请选择" style="width:400px;">
                        <el-option  v-for="(item,index) in infoTypes" :key="index"  :label="item.item_name"  :value="item.item_value"> </el-option>
                     </el-select>
				   </el-form-item>
				<el-form-item label="标题" prop="title">
					 <el-input v-model="editForm.title" auto-complete="off" ></el-input>
				</el-form-item>	

				<el-form-item label="文章" prop="content">
				   <div style="line-height:0px;">
					 <ueditor  :value="value"  v-bind:config="config" v-on:input="input" @ready="ready"></ueditor>
					</div>  
				</el-form-item>	

				<el-form-item label="" prop="click">
					 <el-checkbox v-model="editForm.click">单词点击跳转详情页</el-checkbox>
				</el-form-item>				
			</el-form>
			<div slot="footer" class="dialog-footer" style = "text-align:right;">				
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				<el-button type="primary"  @click.native="backSubmit">返回</el-button>
			</div>
		
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { addArticle,editArticle,getArticle,getArticleBase,ueditServerUrl} from '../../api/api';
   
    import ueditor from '@/components/ueditor.vue';

 let CurrentUserID="",Session=""; 
 var uedit;
	export default {
		  components: {
      ueditor,
    },
		data() {
			
			return {
				    value:'',				 
					config: {
					initialFrameWidth: null,
					initialFrameHeight: 480,
					enableAutoSave: false, //禁止自动保存
                    autoSyncData: false,//自动同步编辑器要提交的数据
					saveInterval:60000*60*24,
					scaleEnabled:true,//设置不自动调整高度
					serverUrl:ueditServerUrl
					},
						
				editLoading: false,
				editFormRules: {
					title: [
						{ required: true, message: '请输入标题', trigger: 'blur' }
					],
					content: [
						{ required: true, message: '请输入内容', trigger: 'blur' }
					]
				},
				infoTypes:[],
				//编辑界面数据
				editForm: {
					id: 0,
					info_type:'01',
					content: '',
					title: '',
					click:true
				},

				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {

            input:function(obj){
                this.editForm.content=obj.content;
              
			},
			  ready:function(obj){
                uedit=obj;

				if (this.formStatus!=0)
				{
				this.getArticle();
				}
              
			},
			getBase(){
             	 this.$http.jsonp(getArticleBase,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						
						this.infoTypes=res.data.infoTypes;	
						
						
					}
					else{                           
						this.$message({
						message:'获取基础信息错误',
						type: 'error'
						});
					}
				

					},
					function(res)
					{
						this.$message({
								message:'获取基础信息错误',
								type: 'error'
								});
						
					});


			},
			//获取用户列表
			getArticle() {
			
                 this.$http.jsonp(getArticle, {params: {id:this.$route.query.id,CurrentUserID:CurrentUserID,Session:Session}}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.editForm = res.data.article;
							  uedit.setContent(this.editForm.content);

							  this.editForm.click=this.editForm.click>0?true:false;
					        
					         this.listLoading = false;
                           
                         }
                         else{   
							  this.listLoading = false;
                              if (res.data.result_code==911)
							  {

                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
								this.$message({
									message:'接口错误',
									type: 'error'
								});

							  }

                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                       this.listLoading = false;
                   }
           )






			},	


			//编辑
			backSubmit: function()
			{
				if (this.formStatus==0)
				{
                     this.$router.push({path: '/articlelist'});
				}
				else {
					window.history.go(-1);
				}
				

			},
		
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							this.editForm.content=uedit.getContent();
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;
							para["PlainTxt"]=uedit.getPlainTxt();
			   let ArticleUrl=addArticle;			  
               if (this.formStatus==1)
			   {
                  ArticleUrl=editArticle;
			   }

               this.$http.post(ArticleUrl,para,{emulateJSON:false}).then(
				
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							   
							    if (this.$refs['editForm'] !== undefined) {						
									this.$refs['editForm'].resetFields();
								}
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.backSubmit();
								// this.editForm =  {
								// 			id: 0,
								// 			info_type:'01',
								// 			content: '',
								// 			title: '',
								// 			click:false
								// 		};
                                //   this.value='';
								//   uedit.setContent(this.value);


								// if (this.formStatus==1)
								// {
								//   this.editFormVisible = false;
								// }
								
                           
                         }
                         else{                           
                            
							 this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.editLoading = false;	
                   }
           )

						});
					}
				});
			},

			 fetchdata(){

				 	this.editForm={
					id: 0,
					info_type:'01',
					content: '',
					title: '',
					click:true };
					this.formStatus=0;                     
					this.value=''; 
					uedit.setContent(this.value);
            
        }
			
			
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
            this.getBase();
           
			if (this.$route.query.status!=undefined && this.$route.query.status!=null)
			{
			  this.formStatus=this.$route.query.status;
			}
			else{                  
			
				     this.formStatus=0;
			}
             
			
			
			
		},
		watch:{
				'$route':'fetchdata'
			}

	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// articleedit.vue?51461466